module.exports = __webpack_public_path__ + "static/media/komb-is-correct.35dd03bd.mp3";